type Props = {
  /** オーバーレイを表示するか */
  visible: boolean
}

/**
 * 抽選中に表示するフルスクリーン GIF オーバーレイ。
 * LOTTERY 型の acquiring state 中のみ表示する。
 */
export function LotteryDrawingOverlay({ visible }: Props) {
  if (!visible) return null
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/75">
      <img src="/images/raund3.gif" alt="抽選中..." className="h-[240px] w-[240px] object-contain" />
    </div>
  )
}
